const SYSTEM_LANGUAGE_LOCALE = "SYSTEM_LANGUAGE_LOCALE"

export const getSystemLanguageLocale = () => localStorage.getItem(SYSTEM_LANGUAGE_LOCALE) as string

export const setSystemLanguageLocale = (locale: string) => localStorage.setItem(SYSTEM_LANGUAGE_LOCALE, locale)
